import { Form, DatePicker, InputNumber, Col } from 'antd';

export default function StatementPatch({name, modalLoading, restField}) {
  const wrapperCol = {span: 24};

  return (
    <>
      <Col span={4}>
        <Form.Item
          {...restField}
          name={[name, "lastPaymentDate"]}
          wrapperCol={wrapperCol}
          extra={<small>Last Payment Date</small>}
          // extra={<small>Please click on cross (on hover) this if you do not wish to update the last payment date.</small>}
          rules={[
              {
              required: false,
              message: 'Please input Last payment Date',
              },
          ]}
          >
          <DatePicker format="YYYY-MM-DD"/>
        </Form.Item>
      </Col>
      <Col span={5}>
        <Form.Item
          {...restField}
          name={[name, "scheduledMonthlyPayment"]}
          wrapperCol={wrapperCol}
          rules={[
              {
              required: true,
              message: 'Please input Statement Date',
              },
          ]}
          extra={<small>Scheduled Monthly Payment</small>}
          >
          <InputNumber
            min="0"
            step="0.01"/>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          {...restField}
          name={[name, "actualMonthlyPayment"]}
          wrapperCol={wrapperCol}
          rules={[
              {
              required: true,
              message: 'Please input Statement Date',
              },
          ]}
          disabled={modalLoading}
          extra={<small>Actual Monthly Payment</small>}
          >
          <InputNumber
            min="0"
            step="0.01"/>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          {...restField}
          name={[name, "currentBalance"]}
          wrapperCol={wrapperCol}
          rules={[
            {
            required: true,
            message: 'Please input Current Balance',
            },
          ]}
          extra={<small>Current Balance</small>}
          >
          <InputNumber
            min="0"
            step="0.01"/>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          {...restField}
          name={[name, "amountPastDue"]}
          wrapperCol={wrapperCol}
          rules={[
            {
            required: true,
            message: 'Please input Amount Past Due',
            },
          ]}
          extra={<small>Amount Past Due</small>}
          >
          <InputNumber
            min="0"
            step="0.01"/>
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item
        {...restField}
        name={[name, "daysDelinquent"]}
        wrapperCol={wrapperCol}
        rules={[
            {
            required: true,
            message: 'Please input Delinquent days',
            },
        ]}
        extra={<small>Days Delinquent</small>}
        >
          <InputNumber />
        </Form.Item>
      </Col>
      <Col span={3}>&nbsp;</Col>
    </>
  );
}